import React, { useState } from 'react';

import Image from 'next/image';

import { useSelector } from 'react-redux';
import { BENEFITS_WELLNESS } from '@/utils/assets';
import componentsId from '@/utils/componentsId';

import styles from './BenefitsWellness.module.scss';
import Section from '@/components/Section';
import Icon from '@/designSystem/Icon';
import AvailablePlanModal from '@/components/AvailablePlanModal';
import { AvailablePlans as AvailablePlansType } from '@/src/types/availablePlans';
import * as plansSelectors from '@/redux/plans/selectors';
import { UF as UFType } from '@/src/types/uf';
import * as ufSelectors from '@/redux/uf/selectors';

const title = 'Fomentamos el equilibrio entre el trabajo y la vida personal';
const subtitle =
  'Beneficios que no esperabas encontrar en un seguro colectivo, pero que tus trabajadores estarán felices de recibir.';

const tabs = [
  {
    tab: 'Yoga y Pilates',
    body: () => (
      <>
        Actívate con nuestra plataforma en línea, donde podrás agendar clases personalizadas de yoga
        y pilates.
      </>
    ),
    img: BENEFITS_WELLNESS.BENEFIT_IMG_YOGA,
  },
  {
    tab: 'Descuentos para el hogar',
    body: () => (
      <>Descuentos en tecnología, seguridad, electrodomésticos, insumos de limpieza y mucho más.</>
    ),
    img: BENEFITS_WELLNESS.BENEFIT_IMG_HOME,
  },
  {
    tab: 'Disfruta tu tiempo libre',
    body: () => (
      <>
        Si te gusta leer, aprender idiomas o tener una aventura outdoor, tenemos descuentos para ti.
      </>
    ),
    img: BENEFITS_WELLNESS.BENEFIT_IMG_FREETIME,
  },
  {
    tab: 'Mascotas',
    body: (handleClick: () => void) => (
      <>
        Consultas de telemedicina veterinaria para cuidar a tus mascotas, con todos nuestros planes
        y asistencia <strong>Pawer</strong> para mascotas con el plan{' '}
        <button onClick={handleClick}>Elite.</button>
      </>
    ),
    img: BENEFITS_WELLNESS.BENEFIT_IMG_DOG,
  },
];

const BenefitsWellness = () => {
  const [activeTab, setActiveTab] = React.useState(tabs[0].tab);
  const handleClick = (tab: string) => {
    setActiveTab(tab === activeTab ? '' : tab);
    setLastSelected(tab);
  };

  const availablePlans: AvailablePlansType = useSelector(plansSelectors.getAvailablePlans);

  const [lastSelected, setLastSelected] = useState(tabs[0].tab);

  const selected = tabs.find((tab) => tab.tab === lastSelected);

  const UF: UFType = useSelector(ufSelectors.getUF);

  const availablePlan = availablePlans?.find((plan) => plan.base === 'elite');
  const [showPlanDetails, setShowPlanDetails] = useState(false);

  return (
    <Section id={componentsId.benefits.pyme.section} customClass={styles.section}>
      {availablePlan && (
        <AvailablePlanModal
          isOpen={showPlanDetails}
          handleClose={() => setShowPlanDetails(false)}
          plan={availablePlan}
          coverages={availablePlan.coverage}
          isElite
          UF={UF}
          theme="secondary"
        />
      )}

      <div className={styles.tab_container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
        {tabs.map((tab) => (
          <div key={tab.tab} className={styles.tab_section}>
            <div className={styles.tab}>
              {tab.tab}
              <button
                className={tab.tab === activeTab ? styles.active : ''}
                onClick={() => handleClick(tab.tab)}
              >
                <Icon name="keyboard_arrow_down" />
              </button>
            </div>
            {tab.tab === activeTab && (
              <div className={styles.body}>{tab.body(() => setShowPlanDetails(true))}</div>
            )}
          </div>
        ))}
        <div className={styles.break} />
        {selected && (
          <div className={styles.image_container}>
            <Image className={styles.image} src={selected.img} alt="" height={665} width={502} />
          </div>
        )}
      </div>
    </Section>
  );
};

export default BenefitsWellness;
